import { Link } from "react-router-dom";

/**
 * PriceCard
 * Props: featured, tag, tagVariant, tier, price, cents, period,
 *        note, noteVariant, items, ctaLabel, ctaVariant, ctaHref
 */
export default function PriceCard({
  featured = false,
  tag, tagVariant = "best",
  tier,
  price, cents,
  period,
  note, noteVariant = "default",
  items = [],
  ctaLabel, ctaVariant = "outline",
  ctaHref = "/contatti",
}) {
  return (
    <div className={`pc${featured ? " pop" : ""}`}>
      {featured && <div className="pop-badge">Più scelto</div>}

      {tag && <div className={`ptag ${tagVariant}`}>{tag}</div>}

      <div className="price-header">
        <span className="price-tier">{tier}</span>
        <div className="price-row">
          <span className="price-currency">€</span>
          <span className="price-number">{price}</span>
          {cents && <span className="price-cents">{cents}</span>}
        </div>
        <span className="price-period">{period}</span>
      </div>

      {note && <div className={`pnote${noteVariant !== "default" ? ` ${noteVariant}` : ""}`}>{note}</div>}

      <ul className="pl">
        {items.map((item, i) => (
          <li key={i}>
            <span className={item.ok ? "ck" : "cx"}>{item.ok ? "✓" : "—"}</span>
            <span style={item.ok ? {} : { color:"var(--muted)" }}>{item.label}</span>
          </li>
        ))}
      </ul>

      <Link
        to={ctaHref}
        className={`btn pc-cta ${ctaVariant === "primary" ? "btn-p" : "btn-o"}`}
        style={{ width:"100%", justifyContent:"center", textDecoration:"none" }}
      >
        {ctaLabel}
      </Link>
    </div>
  );
}
